import React from 'react';
import { api } from '../../api';
import { colors as themeColors, fontFamily as themeFontFamily } from '../../theme';

export default function RulesView() {
  const [rules, setRules] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    api.getRules()
      .then(data => { setRules(data.rules || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4">
      <h2 className="text-xl md:text-2xl font-bold" style={{ color: themeColors.textPrimary, fontFamily: themeFontFamily }}>
        Rules
      </h2>

      <div style={{ background: themeColors.cardBg, boxShadow: themeColors.shadowCard, borderRadius: 8, padding: '1.5rem' }}>
        {loading && <p style={{ color: themeColors.textMuted }}>Loading…</p>}
        {!loading && rules.length === 0 && (
          <p style={{ color: themeColors.textMuted, fontSize: '0.9rem' }}>No rules have been published yet.</p>
        )}
        {!loading && rules.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
            {rules.map((item, i) => (
              <div key={item.id} style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
                <span style={{ color: themeColors.gold, fontWeight: 700, minWidth: 24, flexShrink: 0, fontFamily: themeFontFamily }}>{i + 1}.</span>
                <span style={{ color: themeColors.textPrimary, fontSize: '0.95rem', lineHeight: 1.6, fontFamily: themeFontFamily }}>{item.content}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
